import { useState as d, useEffect as g } from "react";
const n = {
  tabIndex: "tabIndex",
  title: "title",
  ariaLabel: "aria-label",
  ariaLabelledBy: "aria-labelledby",
  ariaDescribedBy: "aria-describedby",
  ariaHidden: "aria-hidden",
  ariaDisabled: "aria-disabled",
  ariaPressed: "aria-pressed",
  ariaExpanded: "aria-expanded",
  ariaHasPopup: "aria-haspopup",
  ariaControls: "aria-controls",
  ariaChecked: "aria-checked",
  ariaMultiselectable: "aria-multiselectable",
  ariaActivedescendant: "aria-activedescendant",
  ariaInvalid: "aria-invalid",
  ariaRequired: "aria-required",
  ariaPlaceholder: "aria-placeholder",
  ariaMultiline: "aria-multiline",
  ariaReadOnly: "aria-readonly",
  ariaAutoComplete: "aria-autocomplete",
  ariaActiveDescendant: "aria-activedescendant",
  ariaOwns: "aria-owns",
  ariaValuMin: "aria-valuemin",
  ariaValuMax: "aria-valuemax",
  ariaValuText: "aria-valuetext",
  ariaValuenow: "aria-valuenow",
  ariaLive: "aria-live",
  ariaBusy: "aria-busy",
  ariaModal: "aria-modal",
  ariaSelected: "aria-selected"
}, {
  tabIndex: B,
  ariaChecked: c,
  ariaDisabled: k,
  ariaLabel: w,
  ariaLabelledBy: M,
  ariaDescribedBy: L,
  ariaHidden: f,
  ariaPressed: V,
  ariaExpanded: o,
  ariaHasPopup: b,
  ariaControls: A,
  ariaMultiselectable: p,
  ariaInvalid: x,
  ariaRequired: m,
  ariaPlaceholder: D,
  ariaMultiLine: C,
  ariaReadOnly: O,
  ariaAutoComplete: R,
  ariaActiveDescendant: T,
  ariaOwns: E,
  ariaValuMin: H,
  ariaValuMax: S,
  ariaValuText: q,
  ariaValuenow: N,
  ariaLive: j,
  ariaBusy: U,
  ariaModal: z,
  ariaSelected: F
} = n, t = [
  w,
  M,
  L,
  f,
  k,
  B
], G = [
  ...t,
  V,
  o,
  b,
  A
], J = [
  ...t,
  H,
  S,
  q,
  N,
  j,
  U
], K = [...t], Q = [...t, c], W = [...t, c], X = [...t, c], Y = [...t], Z = [...t, p], _ = [...t, F], $ = [...t, z], aa = [
  ...t,
  p,
  o,
  x,
  m
], ia = [
  ...t,
  m,
  D,
  x,
  O,
  C,
  R,
  A,
  o,
  b,
  T,
  E
], ta = [...t], ea = {
  button: G,
  switch: Q,
  region: K,
  listitem: Y,
  listbox: Z,
  option: _,
  input: ia,
  progressbar: J,
  dialog: $,
  checkbox: W,
  radio: X,
  combobox: aa,
  link: ta
}, ca = (a, e, r) => {
  const [h, v] = d(!1), [P, y] = d(!1);
  g(() => {
    a === "button" && r?.current?.tagName === "BUTTON" && v(!0), a === "button" && r?.current?.tagName === "A" && y(!0);
  }, [r, a]);
  const i = ((u, I) => {
    const l = {};
    return Object.keys(u).forEach((s) => {
      I.includes(n[s]) && (l[n[s]] = u[s]);
    }), l;
  })(e, ea[a]);
  return (() => {
    switch (a) {
      case "button":
        return {
          ...!h && {
            role: P ? "link" : a,
            tabIndex: e.tabIndex || 0
          },
          ...i
        };
      case "input":
        return {
          ...i
        };
      case "progressbar":
        return {
          role: a,
          ...i
        };
      case "region":
        return {
          role: a,
          ...i
        };
      case "switch":
        return {
          role: a,
          tabIndex: e.tabIndex || 0,
          ...i
        };
      case "listbox":
        return {
          role: a,
          ...i
        };
      case "option":
        return {
          role: a,
          ...i
        };
      case "dialog":
        return {
          role: a,
          ...i
        };
      case "listitem":
        return {
          ...i
        };
      case "checkbox":
        return {
          role: a,
          tabIndex: e.tabIndex || 0,
          ...i
        };
      case "radio":
        return {
          role: a,
          // tabIndex: data.tabIndex || 0,
          ...i
        };
      case "combobox":
        return {
          role: a,
          ...i
        };
      case "link":
        return {
          role: a,
          ...i
        };
      default:
        return {};
    }
  })();
};
export {
  ca as useAccessibilityProps
};
